module.exports = __webpack_public_path__ + "img/BeccaF4.5e1bdc6a.jpg";